import gql from 'graphql-tag';

export default gql`
    query GetAllAssetLoadTypes{
        getAllAssetLoadTypes{
            id
            name
        }
    }
`;
